export const SEARCH = "blog/search";
export const CATEGORYBYFILTER = "blog/categorybyfilter";
export const AUTHORBYFILTER = "blog/authorbyfilter";
